import Swal from "sweetalert2";

export const ErrorAlert = (title: string, error: string) => {
  Swal.fire({
    icon: "error",
    title,
    text: "Error: " + error,
  });
};

export const SuccessAlert = (title: string, text: string) => {
  const htmlText = text.replace(/\n/g, "<br>");

  Swal.fire({
    icon: "success",
    title,
    html: htmlText,
  });
};

export const WarningAlert = (title: string, text: string) => {
  Swal.fire({
    icon: "warning",
    title,
    text,
  });
};

export const ConfirmAlert = async (
  title: string,
  text: string,
  confirmText: string,
  denyText: string
): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    showDenyButton: true,
    confirmButtonText: confirmText,
    denyButtonText: denyText,
    confirmButtonColor: '#00A8A9',
    denyButtonColor: '#999999',
    customClass: {
      confirmButton: 'swal-button-font',
      denyButton: 'swal-button-font',
    },
  });

  if (result.isConfirmed) {
    return true;
  } else if (result.isDenied) {
    return false;
  }
  return false;
};
